<script lang="ts">
    import Fa from 'svelte-fa'
    import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons'
    import FieldHeading from './field-heading.svelte'
    import { ACNE_SCAR_OPTIONS, type AcneScarValue } from '../../types/acne-scar'

    export let label: string
    export let data: Record<string, any>
    export let value: AcneScarValue = []
    export let required = false
    export let readOnly = false

    function toggle(key: string, checked: boolean) {
        if (readOnly) return
        value = checked ? [...value, key] : value.filter((v) => v !== key)
    }
</script>

<div class="view-field">
    <FieldHeading {label} {required} {readOnly} />
    <div class="scar-list">
        {#each ACNE_SCAR_OPTIONS as option (option.key)}
            <label class="scar-row" class:disabled={readOnly} class:selected={value?.includes(option.key)}>
                <input
                    type="checkbox"
                    checked={value?.includes(option.key)}
                    disabled={readOnly}
                    on:change={(e) => toggle(option.key, e.currentTarget.checked)}
                />
                <span class="scar-label">
                    {option.label}
                    <span class="scar-tooltip-icon" title={option.tooltip}>
                        <Fa icon={faCircleQuestion} />
                    </span>
                </span>
            </label>
        {/each}
    </div>
</div>

<style>
    .view-field {
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    .scar-list {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
        gap: 8px;
        width: 100%;
    }
    .scar-row {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 10px 14px;
        border-radius: 8px;
        background: #f8f9fa;
        cursor: pointer;
        min-width: 0;
    }
    .scar-row.disabled {
        cursor: not-allowed;
    }
    .scar-row.selected {
        background: var(--cs2-accent-hover, #17be5e);
    }
    .scar-row input[type='checkbox'] {
        width: 16px;
        height: 16px;
        accent-color: var(--cs2-accent, #1bdf6f);
        flex-shrink: 0;
    }
    .scar-label {
        display: flex;
        align-items: center;
        gap: 6px;
        min-width: 0;
        font-weight: 600;
        font-size: 0.85rem;
        color: #212529;
    }
    .scar-row.selected .scar-label {
        color: #1f2937;
    }
    .scar-tooltip-icon {
        font-size: 0.72rem;
        color: #adb5bd;
        cursor: help;
    }
    .scar-row.selected .scar-tooltip-icon {
        color: #1f2937;
        opacity: 0.75;
    }
</style>
